export default "__VITE_ASSET__CUV8Cqml__"